module.exports = __webpack_public_path__ + "bewe.jpg?67db9a62d513d9adfd7f37b627a149a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/bewe.jpg
// module id = 105
// module chunks = 0